import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  FormGroup,
  Label,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import APIClient from "../../helpers/APIClient";
import Loader from "../../components/Loader";
import { connect } from "react-redux";
import { baseUrl, payment_method } from "../../constants/environment";
import { checkRole } from "../../helpers/Roles";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import IconCalendar from "../../assets/images/icon/ic_calendar-black.svg";
import styled from "styled-components";
import { PaymentMethod, ReceiptsGroup } from "./ReceiptsList";
import NumberFormat from "react-number-format";
import TextUtils from "../../helpers/TextUtils";
import AsyncSelect from "react-select/async";
import { Link } from "react-router-dom";
import { getLinkBySourceCode } from "../../helpers/SourceCode";
import PriceUtils from "../../helpers/PriceUtils";
import MessageManager from "../../manager/MessageManager";
import ModalPopup from "../../components/ModalPopup";
import { RenderActionModal } from "../order/OrderList";
import { cloneDeep } from "lodash";
import { useReactToPrint } from 'react-to-print';
import ReceiptsPrint from './components/ReceiptsPrint'
import { useHistory } from "react-router-dom";

const Detail = (props: any) => {
  const [customers, setCustomers] = useState<any>([]);
  const [users, setUser] = useState<any>([]);
  const [branch, setbranch] = useState<any>([]);
  const [supplier, setSupplier] = useState<any>([]);
  const [receipts_type, setReceipts_type] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({
    day: moment().valueOf(),
    branch_id: props?.user?.branch_id?.id,
  });
  const [dataCustomer, setDataCustomer] = useState<any>({});
  const [dataSupplier, setDataSupplier] = useState<any>({});
  const [isSource, setIsSource] = useState<any>(false);
  const [isCustomer, setIsCustomer] = useState<any>(false);
  const [isSupplier, setIsSupplier] = useState<any>(false);
  const [paymentMethod, setPaymentMethod] = useState<any>([]);
  const [paymentSynce, setPaymentSynce] = useState<any>([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [actionInner, setActionInner] = useState<any>();
  const [vnpayTerminal, setVNPayTerminal] = useState<any>([]);
  const [fundaccount, setFundaccount] = useState<any>([]);
  const [dataCheck, setDataCheck] = useState<any>([])
  const [dataCurrent, setDataCurrent] = useState<any>([]);
  const [actionType, setActionType] = useState<any>();
  const [view, setView] = useState<any>();
  const { closeModal, action, onlyView, designation_ids } = props;

  const [dataPrint, setDataPrint] = useState<any>([]);
  const [branchPrint, setBranchPrint] = useState<any>([])
  const [doctorPrint, setDoctorPrint] = useState<any>([])
  const [customerPrint, setCustomerPrint] = useState<any>([])
  const [service_package_print, setService_package_print] = useState<any>([]);
  const [type_payment_method_id, setType_payment_method_id] = useState<any>();
  const componentRef = useRef(null)
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => closeModal(),
    copyStyles: true,
  });

  const router = useHistory();

  const paymentSynceRef = useRef<any>(null);
  useEffect(() => {
    paymentSynceRef.current = paymentSynce;
  }, [paymentSynce]);

  const type = action?.type;

  useEffect(() => {
    loadInit();
    setActionType(action?.type);
    setView(onlyView);
    MessageManager.addListener({
      onUpdatePaymentStatusReceipt,
    });
    return () => {
      MessageManager.removeListener("onUpdatePaymentStatusReceipt");
    };
  }, []);
  useEffect(() => {
    loadDataFundaccount();
  }, [type_payment_method_id, data?.branch_id])

  const onUpdatePaymentStatusReceipt = (dataPayment: any) => {
    const clonePaymentSynce: any = cloneDeep(paymentSynceRef?.current);
    const newPaymentSynce = clonePaymentSynce?.reduce(
      (prev: any, item: any) => {
        if (item?.id === dataPayment?.id) {
          if (item.status !== dataPayment.status) {
            if (item.status === 1)
              toast.success(
                `Phiếu thu ${item?.code
                } vừa nhận được thanh toán: ${PriceUtils.format(
                  item?.payment_total,
                  " đ"
                )}`
              );
            if (item.status === -1)
              toast.success(
                `Phiếu thu ${item?.code} chuyển trạng thái thất bại`
              );
          }
          item.status = dataPayment?.status;
        }
        prev = [...prev, item];
        return prev;
      },
      []
    );
    setPaymentSynce(newPaymentSynce);
  };

  useEffect(() => {
    if (action?.data?.id) {
      loadData(action?.data?.id);
    }
  }, [action?.data]);

  useEffect(() => {
    if (props?.designation_id) {
      setIsSource(true);
      loadSearchCodeDetailDesignation(props?.designation_id);
    }
  }, [props?.designation_id]);

  useEffect(() => {
    if (props?.designation_ids) {
      setIsSource(true);
      loadAllDesignationDetailSync(props?.designation_ids);
    }
  }, [props?.designation_ids]);

  useEffect(() => {
    if (props?.orders_id) {
      setIsSource(true);
      loadSearchCodeDetailOrders(props?.orders_id);
    }
  }, [props?.orders_id]);

  useEffect(() => {
    if (props?.orders_id_service_package) {
      setIsSource(true);
      Array.isArray(props?.orders_id_service_package) ? loadSearchCodeDetailOrders_servicePackages(props?.orders_id_service_package) :
        loadSearchCodeDetailOrders_servicePackage(props?.orders_id_service_package)
    }
  }, [props?.orders_id_service_package])

  useEffect(() => {
    if (props?.customer_id) {
      setIsCustomer(true);
      loadDataCustomer(props?.customer_id);
    }
  }, [props?.customer_id]);

  useEffect(() => {
    if (props?.supplier_id) {
      setIsSupplier(true);
      loadDataSupplier(props?.supplier_id);
    }
  }, [props?.supplier_id]);

  useEffect(() => {
    loadReceiptsType();
  }, [data?.receipts_group]);

  useEffect(() => {
    if (props?.orders_ids) {
      setIsSource(true);
      loadAllOrdersDetailSync(props?.orders_ids);
    }
  }, [props?.orders_ids]);

  useEffect(() => {
    loadVNPayTerminal();
  }, [data?.branch_id]);

  useEffect(() => {
    loadServiceCode();
  }, [data?.source_code])

  const handleActionModal = (item: any) => {
    setActionInner(item);
    setIsOpen(true);
  };

  const loadInit = async () => {
    const params = {
      status: 1,
      page: 1,
      limit: 300,
    };
    const [
      responseType,
      responseUser,
      responseBranch,
      responseCustomer,
      responseSupplier,
      responsePaymentMethod,
    ] = await Promise.all([
      APIClient.GET(`${baseUrl}/receiptstype`, {
        ...params,
        type: "receipts",
      }),
      APIClient.GET(`${baseUrl}/user`, {
        ...params,
      }),
      APIClient.GET(`${baseUrl}/branch`, {
        ...params,
      }),
      APIClient.GET(`${baseUrl}/customer`, {
        ...params,
        limit: 3000,
      }),
      APIClient.GET(`${baseUrl}/supplier`, {
        ...params,
      }),
      APIClient.GET(`${baseUrl}/payment-method`, {
        ...params,
        include_vnpay: true,
      }),
    ]);
    if (responsePaymentMethod.response?.data !== undefined) {
      let ListArr: any = [];
      responsePaymentMethod.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setPaymentMethod(ListArr);
    }
    if (responseType.response?.data !== undefined) {
      let ListArr: any = [];
      responseType.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setReceipts_type(ListArr);
    }
    if (responseUser.response?.data !== undefined) {
      let ListArr: any = [];
      responseUser.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setUser(ListArr);
    }
    if (responseBranch.response?.data !== undefined) {
      let ListArr: any = [];
      responseBranch.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setbranch(ListArr);
      let Arr: any = ListArr?.filter((item: any) => item?.id == data?.branch_id)
      setBranchPrint(Arr)
    }
    if (responseCustomer.response?.data !== undefined) {
      let ListArr: any = [];
      responseCustomer.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setCustomers(ListArr);
    }
    if (responseSupplier.response?.data !== undefined) {
      let ListArr: any = [];
      responseSupplier.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setSupplier(ListArr);
    }
  };

  const loadVNPayTerminal = async () => {
    if (!data?.branch_id) return;
    const params = {
      status: 1,
      page: 1,
      limit: 100,
    };
    const [responseType] = await Promise.all([
      APIClient.GET(`${baseUrl}/vnpay-terminal`, {
        ...params,
        branch_id: data?.branch_id,
      }),
    ]);
    if (responseType.response?.data !== undefined) {
      let ListArr: any = [];
      responseType.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setVNPayTerminal(ListArr);
    }
  };

  const loadReceiptsType = async () => {
    const params = {
      status: 1,
      page: 1,
      limit: 100,
    };
    const [responseType] = await Promise.all([
      APIClient.GET(`${baseUrl}/receiptstype`, {
        ...params,
        type: "receipts",
        classify: data?.receipts_group,
      }),
    ]);
    if (responseType.response?.data !== undefined) {
      let ListArr: any = [];
      responseType.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setReceipts_type(ListArr);
    }
  };

  const loadData = async (id: number) => {
    const url = `${baseUrl}/receipts/${id}`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response;
      const data = {
        ...resData,
        payment_method_id: resData?.payment_method_id?.id,
        vnpay_terminal_id: resData?.vnpay_terminal_id?.id,
        customer_submitter_uid: resData?.customer_submitter_uid?.id,
        user_submitter_uid: resData?.user_submitter_uid?.id,
        receipts_type_id: resData?.receipts_type_id?.id,
        receipts_uid: resData?.receipts_uid?.id,
        fundaccount_id: resData?.fundaccount_id?.id,
        // branch_id: resData?.branch_id?.id,
        branch_id: props?.user?.branch_id?.id,
        source_code: JSON.parse(resData?.source_code),
      }
      setDataCheck(data)
      setData(data);
      setDataCurrent(data)
    }
  };

  // tài khoản quỹ
  const loadDataFundaccount = async () => {
    const params = {
      // status: 1,
      page: 1,
      limit: 100,
      type: type_payment_method_id?.fundaccount_type
    };
    const url = `${baseUrl}/fundaccount`;
    setLoading(true);
    let response = await APIClient.GET(url, params)
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description)
    } else if (response.response !== undefined) {
      const resData = response.response;
      let ListArr: any = [];
      resData?.data?.map((e: any) => {
        if (e?.status == 1 && e?.branch_id?.id == data?.branch_id) {
          ListArr?.push({
            ...e,
            value: e?.id,
            label: e?.name,
          });
        }
      });
      setFundaccount(ListArr)
    }
  }

  //thông tin khash hàng
  const loadDataCustomer = async (id: number) => {
    const url = `${baseUrl}/customer/${id}`;
    setLoading(true);
    const [response, responseCode]: any = await Promise.all([
      await APIClient.GET(url),
      await APIClient.GET(`${baseUrl}/search/source-code-none-paid/customer`, {
        customer_id: id,
      }),
    ]);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response;


      if (resData?.total_debt < 0) {
        toast.error("Hiện tại khách hàng ko có công nợ để tạo phiếu thu");
        closeModal();
      }
      if (responseCode.response !== undefined) {
        const code = responseCode.response?.data?.reduce(
          (prev: any, item: any) => {
            prev = [...prev, item?.code];
            return prev;
          },
          []
        );
        data.source_code = code;
      }
      setDataCustomer(resData);
      setData({
        ...data,
        payment_total: resData?.total_debt,
        max_payment_total: resData?.total_debt,
        receipts_group: "customer",
        receipts_uid: props?.user?.id,
        customer_submitter_uid: Number(props?.customer_id),
        branch_id: props?.user?.branch_id?.id,
      });
    }
  };
  //thông tin nhà cung cấp
  const loadDataSupplier = async (id: number) => {
    const url = `${baseUrl}/supplier/${id}`;
    setLoading(true);
    const [response, responseCode]: any = await Promise.all([
      await APIClient.GET(url),
      await APIClient.GET(`${baseUrl}/search/source-code-none-paid/supplier`, {
        supplier_id: id,
      }),
    ]);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response;
      if (resData?.total_debt > 0) {
        toast.error("Hiện tại nhà cung cấp ko có công nợ để tạo phiếu thu");
        closeModal();
      }
      if (responseCode.response !== undefined) {
        const code = responseCode.response?.data?.reduce(
          (prev: any, item: any) => {
            prev = [...prev, item?.code];
            return prev;
          },
          []
        );
        data.source_code = code;
      }
      setData({
        ...data,
        receipts_group: "supplier",
        payment_total: -resData?.total_debt,
        max_payment_total: -resData?.total_debt,
        receipts_uid: props?.user?.id,
        supplier_submitter_uid: Number(props?.supplier_id),
        branch_id: props?.user?.branch_id?.id,
      });
      setDataSupplier(resData);
    }
  };

  //dịch vụ chỉ định
  const loadAllDesignationDetailSync = async (designation_ids: any) => {
    setLoading(true);
    const dataAll: any = await loadAllDesignationDetail(designation_ids);
    const checkCusstomer = dataAll?.reduce((prev: any, item: any) => {
      if (dataAll[0]?.customer_id?.id !== item?.customer_id?.id) {
        prev = false;
      }
      return prev;
    }, true);
    const { total, codes }: any = dataAll?.reduce(
      (prev: any, item: any) => {
        const totalPayment = item?.designation_payments?.reduce(
          (prevPayment: any, itemPayment: any) => {
            if (itemPayment?.payment_total) prevPayment = prevPayment + Number(itemPayment?.payment_total);
            return prevPayment;
          },
          0
        );
        // const totalService = item?.designation_services?.reduce(
        //   (prevService: any, itemService: any) => {
        //     prevService = prevService + ((Number(itemService?.service_price || 0) * Number(itemService?.service_quantity || 0)) - Number(itemService?.service_discount || 0));
        //     return prevService;
        //   },
        //   0
        // );
        const totalService = Number(item?.sub_total || 0)
        const payment_total = totalService - totalPayment;
        if (payment_total > 0) {
          prev = {
            total: prev?.total + payment_total,
            codes: [...prev?.codes, item?.code],
          };
        }
        return prev;
      },
      {
        total: 0,
        codes: [],
      }
    );
    setLoading(false);

    if (!checkCusstomer) {
      toast.error("Chỉ có thể thu tiền cho nhiều phiếu của 1 khách hàng");
      closeModal();
      return;
    }
    if (codes?.length === 0) {
      toast.error("Các dịch vụ trên đã được thanh toán");
      closeModal();
      return;
    }
    if (codes?.length !== dataAll?.length) {
      toast.warning(
        "Đã loại bỏ một số dịch vụ đã thanh toán ra khỏi phiếu thu tiền"
      );
    }

    setData({
      ...data,
      receipts_group: "customer",
      receipts_uid: props?.user?.id,
      customer_submitter_uid: dataAll[0]?.customer_id?.id,
      // branch_id: resData?.branch_id?.id,
      branch_id: props?.user?.branch_id?.id,
      max_payment_total: total,
      source_code: codes,
      payment_total: total,
    });
  };

  const loadSearchCodeDetailDesignation = async (id: number) => {
    const url = `${baseUrl}/designation/${id}`;
    setLoading(true);
    let response: any = await APIClient.GET(url, { include_orderspackage: true });
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = await response.response;
      const totalPayment = resData?.designation_payments?.reduce(
        (prev: any, item: any) => {
          if (item?.payment_total) prev = prev + Number(item?.payment_total);
          return prev;
        },
        0
      );
      const payment_total = Number(resData?.sub_total || 0)- Number(totalPayment || 0)
      // const totalService = resData?.designation_services?.reduce(
      //   (prev: any, item: any) => {
      //     prev = prev + ((Number(item?.service_price || 0) * Number(item?.service_quantity || 0)) - Number(item?.service_discount || 0) - Number(item?.service_discount_by_package || 0));
      //     return prev;
      //   },
      //   0
      // );
      // let discount = 0;
      // const discount_service = resData?.designation_services?.[0]?.service_id?.partner == null ? 
      // discount = Number(resData?.examination_id?.service_package_id?.discount_service_examination || 0) / 100
      // : discount = Number(resData?.examination_id?.service_package_id?.discount_service_partner_examination || 0) / 100
      // const payment_total = totalService - totalPayment - (totalService * discount) ;
      console.log("payment_total", payment_total)
      setData({
        ...data,
        receipts_group: "customer",
        receipts_uid: props?.user?.id,
        customer_submitter_uid: resData?.customer_id?.id,
        source_code: [resData?.code],
        branch_id: resData?.branch_id?.id,
        payment_total,
        max_payment_total: payment_total,
      });
    }
    return;
  };

  const loadAllDesignationDetail = async (designation_ids: any) => {
    const url = `${baseUrl}/designation`;
    const designation: any = await APIClient.GET(url, {
      ids: designation_ids,
      include_service: true,
    });
    return designation?.response?.data || [];
  };

  //đơn hàng
  const loadAllOrdersDetailSync = async (orders_ids: any) => {
    setLoading(true);
    const dataAll: any = await loadAllOrdersDetail(orders_ids);
    const checkCusstomer = dataAll?.reduce((prev: any, item: any) => {
      if (dataAll[0]?.customer_id?.id !== item?.customer_id?.id) {
        prev = false;
      }
      return prev;
    }, true);
    const { total, codes }: any = dataAll?.reduce(
      (prev: any, item: any) => {
        const totalPayment = item?.orders_payment?.reduce(
          (prev: any, item: any) => {
            if (item?.payment_total) prev = prev + Number(item?.payment_total);
            return prev;
          },
          0
        );
        const payment_total = Number(item?.sub_total || 0) - totalPayment;
        if (payment_total > 0) {
          prev = {
            total: prev?.total + payment_total,
            codes: [...prev?.codes, item?.code],
          };
        }
        return prev;
      },
      {
        total: 0,
        payment_total: 0,
        codes: [],
      }
    );
    setLoading(false);

    if (!checkCusstomer) {
      toast.error("Chỉ có thể thu tiền cho nhiều phiếu của 1 khách hàng");
      closeModal();
      return;
    }
    if (codes?.length === 0) {
      toast.error("Các dịch vụ trên đã được thanh toán");
      closeModal();
      return;
    }
    if (codes?.length !== dataAll?.length) {
      toast.warning(
        "Đã loại bỏ một số dịch vụ đã thanh toán ra khỏi phiếu thu tiền"
      );
    }

    setData({
      ...data,
      receipts_group: "customer",
      receipts_uid: props?.user?.id,
      customer_submitter_uid: dataAll[0]?.customer_id?.id,
      // branch_id: resData?.branch_id?.id,
      branch_id: props?.user?.branch_id?.id,
      max_payment_total: total,
      source_code: codes,
      payment_total: total,
    });
  };

  const loadSearchCodeDetailOrders = async (id: number) => {
    const url = `${baseUrl}/orders/${id}`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response;
      const totalPayment = resData?.orders_payment?.reduce(
        (prev: any, item: any) => {
          if (item?.payment_total) prev = prev + Number(item?.payment_total);
          return prev;
        },
        0
      );
      const payment_total =
        Number(resData?.sub_total || 0) -
        totalPayment;
      setData({
        ...data,
        receipts_group: "customer",
        receipts_uid: props?.user?.id,
        customer_submitter_uid: resData?.customer_id?.id,
        source_code: [resData?.code],
        branch_id: resData?.branch_id?.id,
        payment_total,
        max_payment_total: payment_total,
      })
    }
    return;
  };

  // Nếu thanh toán 1 gói thẻ cùng lúc sẽ dùng hàm này
  const loadSearchCodeDetailOrders_servicePackage = async (id: any) => {
    const url = `${baseUrl}/orderspackage/${id}`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response;
      const payment_total =
        Number(resData?.sub_total || 0) -
        Number(resData?.orderspackage_payment?.[0]?.payment_total || 0)
      setData({
        ...data,
        receipts_group: "customer",
        receipts_uid: props?.user?.id,
        customer_submitter_uid: resData?.customer_id?.id,
        source_code: [resData?.code],
        branch_id: resData?.branch_id?.id,
        payment_total,
        max_payment_total: payment_total,
      });
    }
    return;
  }
  // Nếu thanh toán trên 1 gói thẻ cùng lúc sẽ dùng hàm này
  const loadSearchCodeDetailOrders_servicePackages = async (id: any) => {
    setLoading(true);
    try {
      let response;
      if (Array.isArray(id)) {
        response = await Promise.all(
          id.map((item: any) => APIClient.GET(`${baseUrl}/orderspackage/${item}`))
        );
      }
      setLoading(false);
      if (response && !response.some(res => res.error !== undefined)) {
        const resData = response.map(res => res.response);
        const payment_total =
          resData.reduce((acc, item) => acc + Number(item?.sub_total || 0), 0) -
          Number(resData[0]?.orderspackage_payment?.[0]?.payment_total || 0);
        const code = resData.map(item => item?.code).filter(Boolean);
        setData({
          ...data,
          receipts_group: "customer",
          receipts_uid: props?.user?.id,
          customer_submitter_uid: resData[0]?.customer_id?.id,
          source_code: code,
          branch_id: resData[0]?.branch_id?.id,
          payment_total,
          max_payment_total: payment_total,
        });
      } else {
        toast.error("Error loading data");
      }
    } catch (error) {
      toast.error("Error loading data");
    }
  };

  const loadAllOrdersDetail = async (orders_ids: any) => {
    const url = `${baseUrl}/orders`;
    const designation: any = await APIClient.GET(url, {
      ids: orders_ids,
    });
    return designation?.response?.data || [];
  };

  const handleChangeInput = (event?: any) => {
    let { value, name } = event.target;
    if (value === " ") return;
    if (name === "phone") {
      value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "");
    }
    if (name === "payment_total" && data?.max_payment_total) {
      value = data?.max_payment_total;
      toast.warning("Vượt quá số tiền cần phải thanh toán");
    }
    setData({
      ...data,
      [name]: value,
    });
  };

  const [loadingDesignation, setLoadingSearchCode] = useState(false);

  const [queryDesignation, setQueryDesignation] = useState("");

  const loadSearchCode = async () => {
    setLoadingSearchCode(true);
    let response: any = await APIClient.GET(`${baseUrl}/search/source-code`, {
      page: 1,
      limit: 100,
      name: queryDesignation,
    });
    setLoadingSearchCode(false);
    if (response.response?.data !== undefined) {
      let ListArr: any = [];
      response.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.code,
          label: e?.code,
        });
      });
      return ListArr;
    } else {
      return [];
    }
  };

  const loadServiceCode = async () => {
    let response: any = await APIClient.GET(`${baseUrl}/designation`, {
      codes: data?.source_code,
      include_service: true,
      include_orderspackage: true
    })
    if (response.response?.data !== undefined) {
      const dataDes_service: any = await response.response?.data?.map((item: any) => item?.designation_services);
      let dataPrint: any = []
      const dataService: any = dataDes_service?.map((item: any) => {
        item?.map((itemService: any) => {
          dataPrint.push(itemService)
        })
      })
      setService_package_print(response.response?.data?.[0]?.examination_id?.service_package_id)
      setDataPrint(dataPrint);
      setDoctorPrint(response.response?.data?.[0]?.doctor_id)
    }
  }

  const handleInputChangeSearchCode = (newValue: any) => {
    setQueryDesignation(newValue);
    return newValue;
  };

  const source_code = data?.source_code?.reduce((prev: any, item: any) => {
    var id = item?.replace(/\D/g, "");
    prev = [
      ...prev,
      {
        name: item,
        id: Number(id),
      },
    ];
    return prev;
  }, []);

  const validationFrom = () => {
    // if (!(data?.receipts_type_id)) {
    //     toast.warning('Loại phiếu thu không được để trống!');
    //     return false
    // }
    if (!data?.receipts_group) {
      toast.warning("Nhóm phiếu thu không được để trống!");
      return false;
    }
    if (data?.receipts_group === "customer" && !data?.customer_submitter_uid) {
      toast.warning("Người nộp không được để trống!");
      return false;
    } else if (data?.receipts_group === "user" && !data?.user_submitter_uid) {
      toast.warning("Người nộp không được để trống!");
      return false;
    } else if (
      data?.receipts_group === "supplier" &&
      !data?.supplier_submitter_uid
    ) {
      toast.warning("Người nộp không được để trống!");
      return false;
    } else if (data?.receipts_group === "other" && !data?.user_submitter_uid) {
      toast.warning("Người nộp không được để trống!");
      return false;
    }
    if (
      (data?.receipts_group === "supplier" ||
        data?.receipts_group === "customer" || data?.receipts_group === "user") && (source_code?.length === 0 || source_code == undefined)
    ) {
      toast.warning("Mã chứng từ gốc không được để trống!");
      return false;
    }
    if (!data?.day) {
      toast.warning("Ngày thu không được để trống!");
      return false;
    }
    if (!data?.receipts_uid) {
      toast.warning("Người thu không được để trống!");
      return false;
    }
    if (!data?.payment_total) {
      toast.warning("Số tiền không được để trống!");
      return false;
    }
    if (!data?.payment_method_id) {
      toast.warning("Hình thức không được để trống!");
      return false;
    }
    if (!data?.branch_id) {
      toast.warning("Cơ sở không được để trống!");
      return false;
    }
    if (
      [payment_method.vnpay_qr_id, payment_method.vnpay_spos_id].includes(
        Number(data?.payment_method_id)
      ) &&
      !data?.vnpay_terminal_id
    ) {
      toast.warning("Máy POS không được để trống!");
      return false;
    }
    if (!data?.fundaccount_id) {
      toast.warning("Tài khoản quỹ không được để trống!");
      return false;
    }

    return true;
  };
  const handleSubmit = async (type?: boolean) => {
    if (!validationFrom()) return;
    setLoading(true);
    const url = `${baseUrl}/receipts`;
    const params = {
      code: data?.code,
      receipts_type_id: data?.receipts_type_id,
      receipts_group: data?.receipts_group,
      user_submitter_uid: data?.user_submitter_uid,
      customer_submitter_uid: data?.customer_submitter_uid,
      supplier_submitter_uid: data?.supplier_submitter_uid,
      day: moment(data?.day).valueOf(),
      receipts_uid: data?.receipts_uid,
      source_code:
        data?.source_code?.length > 0 ? data?.source_code : undefined,
      payment_total: Number(data?.payment_total),
      payment_method_id: data?.payment_method_id,
      vnpay_terminal_id: data?.vnpay_terminal_id,
      branch_id: data?.branch_id,
      note: data?.note,
      // "status": props?.designation_id ? 1: 0,
      status: 1,
      fundaccount_id: data?.fundaccount_id
    };
    let response: any = await APIClient.POST(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      setCustomerPrint(response.response?.customer_submitter_uid)
      if (response.response?.is_vnpay_qr || response.response?.is_vnpay_sppos) {
        setPaymentSynce([response.response]);
        handleActionModal({
          type: "paymentProcess",
          data: response.response,
          onSubmit: () => {
            toast.success("Tạo phiếu thu thành công");
            if (type !== true) {
              closeModal();
            }
            props.loadData();
            if (typeof props?.loadData_ids === 'function') {
              props.loadData_ids();
            }
            if (type == true) {
              if (!checkRole(props?.user?.roles, ["printReceipts"], props?.user?.role)) {
                return (
                  <CardBody className="p-0" style={{ width: 460 }}>
                    <div className="modal-header">
                      <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                      </h5>
                      <button onClick={() => closeModal()} type="button" className="close">
                        {" "}
                        <span aria-hidden="true">×</span>{" "}
                      </button>
                    </div>
                    <div className="modal-body pt-2 pb-2">
                      <Col md={12}>
                        <FormGroup row className="label-only">
                          <p
                            className="font-size-14"
                            style={{ textAlign: "center", width: "100%" }}
                          >
                            Bạn không có quyền thực hiện thao tác này
                          </p>
                        </FormGroup>
                      </Col>
                    </div>
                    <div className="modal-footer">
                      <Button
                        onClick={closeModal}
                        className="ml-2 success-bland"
                        color="success"
                        type="button"
                      >
                        {" "}
                        Hủy bỏ
                      </Button>
                    </div>
                    {loading && <Loader />}
                  </CardBody>
                )
              }
              setTimeout(() => {
                handlePrint()
              }, 1000);
            }

          },
          onClose: () => {
            toast.success("Tạo phiếu thu thành công");
            // closeModal();
            if (type !== true) {
              closeModal();
            }
            props.loadData();
            if (typeof props?.loadData_ids === 'function') {
              props.loadData_ids();
            }
            if (type == true) {
              if (!checkRole(props?.user?.roles, ["printReceipts"], props?.user?.role)) {
                return (
                  <CardBody className="p-0" style={{ width: 460 }}>
                    <div className="modal-header">
                      <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                      </h5>
                      <button onClick={() => closeModal()} type="button" className="close">
                        {" "}
                        <span aria-hidden="true">×</span>{" "}
                      </button>
                    </div>
                    <div className="modal-body pt-2 pb-2">
                      <Col md={12}>
                        <FormGroup row className="label-only">
                          <p
                            className="font-size-14"
                            style={{ textAlign: "center", width: "100%" }}
                          >
                            Bạn không có quyền thực hiện thao tác này
                          </p>
                        </FormGroup>
                      </Col>
                    </div>
                    <div className="modal-footer">
                      <Button
                        onClick={closeModal}
                        className="ml-2 success-bland"
                        color="success"
                        type="button"
                      >
                        {" "}
                        Hủy bỏ
                      </Button>
                    </div>
                    {loading && <Loader />}
                  </CardBody>
                )
              }
              setTimeout(() => {
                handlePrint()
              }, 1000);
            }
          },
        });
      } else {
        toast.success("Tạo phiếu thu thành công");
        if (type !== true) {
          closeModal();
        }
        props.loadData();
        if (typeof props?.loadData_ids === 'function') {
          props.loadData_ids();
        }
        if (type == true) {
          setTimeout(() => {
            handlePrint()
          }, 1000);
        }
      }
    }
  };

  const handleEdit = async () => {
    if (!validationFrom()) return;
    setLoading(true);
    const url = `${baseUrl}/receipts/${data?.id}`;
    const params = {
      fundaccount_id: data?.fundaccount_id,
      source_code: dataCurrent?.source_code?.length == 0 ? data?.source_code : undefined,
      note: data?.note
    }
    let response: any = await APIClient.PUT(url, params);

    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      toast.success("Chỉnh sửa phiếu thu thành công");
      closeModal();
    }
  }

  const handleUpdateStatus = async (status: any) => {
    setLoading(true);
    const url = `${baseUrl}/receipts/${data?.id}/updateStatus`;
    const params = {
      status: status,
    };
    let response: any = await APIClient.POST(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      loadData(data?.id);
      props.loadData();
      toast.success("Cập nhật trạng thái phiếu thu thành công");
    }
  };

  if (!checkRole(props?.user?.roles, ["addReceipts"], props?.user?.role)) {
    return (
      <CardBody className="p-0" style={{ width: 460 }}>
        <div className="modal-header">
          <h5 className="modal-title" id="modal-action-title">
            Thông báo
          </h5>
          <button onClick={() => closeModal()} type="button" className="close">
            {" "}
            <span aria-hidden="true">×</span>{" "}
          </button>
        </div>
        <div className="modal-body pt-2 pb-2">
          <Col md={12}>
            <FormGroup row className="label-only">
              <p
                className="font-size-14"
                style={{ textAlign: "center", width: "100%" }}
              >
                Bạn không có quyền thực hiện thao tác này
              </p>
            </FormGroup>
          </Col>
        </div>
        <div className="modal-footer">
          <Button
            onClick={closeModal}
            className="ml-2 success-bland"
            color="success"
            type="button"
          >
            {" "}
            Hủy bỏ
          </Button>
        </div>
        {loading && <Loader />}
      </CardBody>
    );
  }

  const btnPrint = () => {
    let status = true;
    let check = data?.source_code?.[0]?.split('-');
    if (check?.[0] !== "CDDV") {
      status = false
    }
    return status
  }

  return (
    <>
      <CardBody className="p-0" style={{ width: 860 }}>
        <div className="modal-header">
          <h5 className="modal-title" id="modal-action-title">
            {actionType === "add"
              ? "Tạo phiếu thu"
              : actionType === "addReceipts"
                ? "Tạo phiếu thu"
                : actionType === "view"
                  ? "Chi tiết phiếu thu"
                  : actionType === "edit"
                    ? "Chỉnh sửa phiếu thu"
                    : "Thông báo"}
          </h5>
          <button onClick={() => closeModal()} type="button" className="close">
            {" "}
            <span aria-hidden="true">×</span>{" "}
          </button>
        </div>
        <div className="modal-body p-4">
          <PageContent className={view ? "only-view" : ""}>
            <Col md={12}>
              <FormGroup row className="label-only">
                <Row>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>Mã phiếu</Label>
                      <Input
                        type="text"
                        value={data?.code}
                        onChange={(e: any) => handleChangeInput(e)}
                        name="code"
                        placeholder="Nhập mã phiếu"
                        disabled={actionType === "edit"}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>
                        <span>*</span> Nhóm phiếu thu
                      </Label>
                      <Select
                        placeholder={
                          actionType === "view" && !data?.receipts_group
                            ? "---"
                            : "Chọn nhóm phiếu thu"
                        }
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView || isSource || isCustomer || actionType == "edit"}
                        onChange={(val: any) => {
                          setData({
                            ...data,
                            receipts_group: val?.value,
                            customer_submitter_uid: null,
                            user_submitter_uid: null,
                          });
                          setDataCustomer({});
                          setDataSupplier({});
                        }}
                        value={ReceiptsGroup?.filter(
                          (option: any) => data?.receipts_group == option.value
                        )}
                        options={ReceiptsGroup}
                        styles={customStyles}
                      ></Select>
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>Loại phiếu thu</Label>
                      <Select
                        placeholder={
                          actionType === "view" && !data?.receipts_type_id
                            ? "---"
                            : "Chọn loại phiếu thu"
                        }
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView || !data?.receipts_group || actionType === "edit"}
                        onChange={(val: any) => {
                          setData({ ...data, receipts_type_id: val?.value });
                        }}
                        value={receipts_type?.filter(
                          (option: any) => data?.receipts_type_id == option.value
                        )}
                        options={receipts_type}
                        styles={customStyles}
                      ></Select>
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>
                        <span>*</span> Người nộp
                      </Label>
                      {data?.receipts_group === "customer" ? (
                        <Select
                          placeholder={
                            actionType === "view" && !data?.customer_submitter_uid
                              ? "---"
                              : "Chọn người nộp"
                          }
                          className="react-select mb-2"
                          classNamePrefix="react-select"
                          isDisabled={
                            onlyView ||
                            isSource ||
                            isCustomer ||
                            !data?.receipts_group || actionType === "edit"
                          }
                          onChange={(val: any) => {
                            setData({
                              ...data,
                              customer_submitter_uid: val?.value,
                            });
                            setDataCustomer(val);
                          }}
                          value={customers?.filter(
                            (option: any) =>
                              data?.customer_submitter_uid == option.value
                          )}
                          options={customers}
                          styles={customStyles}
                        ></Select>
                      ) : data?.receipts_group === "supplier" ? (
                        <Select
                          placeholder={
                            actionType === "view" && !data?.supplier_submitter_uid
                              ? "---"
                              : "Chọn người nộp"
                          }
                          className="react-select mb-2"
                          classNamePrefix="react-select"
                          isDisabled={
                            onlyView ||
                            isSource ||
                            isSupplier ||
                            !data?.receipts_group
                          }
                          onChange={(val: any) => {
                            setData({
                              ...data,
                              supplier_submitter_uid: val?.value,
                            });
                            setDataSupplier(val);
                          }}
                          value={supplier?.filter(
                            (option: any) =>
                              data?.supplier_submitter_uid == option.value
                          )}
                          options={supplier}
                          styles={customStyles}
                        ></Select>
                      ) : (
                        <Select
                          placeholder={
                            actionType === "view" && !data?.user_submitter_uid
                              ? "---"
                              : "Chọn người nộp"
                          }
                          className="react-select mb-2"
                          classNamePrefix="react-select"
                          isDisabled={
                            onlyView || isSource || !data?.receipts_group
                          }
                          onChange={(val: any) => {
                            setData({ ...data, user_submitter_uid: val?.value });
                          }}
                          value={users?.filter(
                            (option: any) =>
                              data?.user_submitter_uid == option.value
                          )}
                          options={users}
                          styles={customStyles}
                        ></Select>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>
                        <span>*</span> Ngày thu
                      </Label>
                      <InputGroup>
                        {(actionType !== undefined && actionType == "add") ? (
                          <Flatpickr
                            value={[new Date(data?.day)]}
                            onChange={(date: any) => {
                              setData({
                                ...data,
                                day: date[0] ? moment(date[0]) : undefined,
                              });
                            }}
                            options={{
                              locale: Vietnamese,
                              allowInput: true,
                              dateFormat: "d/m/Y",
                              altInputClass: "date-range",
                              minDate: "today"
                            }}
                            placeholder="dd/mm/yy"
                            disabled={actionType === "edit"}
                          />
                        ) : (
                          <Flatpickr
                            value={[new Date(data?.day)]}
                            onChange={(date: any) => {
                              setData({
                                ...data,
                                day: date[0] ? moment(date[0]) : undefined,
                              });
                            }}
                            options={{
                              locale: Vietnamese,
                              allowInput: true,
                              dateFormat: "d/m/Y",
                              altInputClass: "date-range",
                            }}
                            placeholder="dd/mm/yy"
                            disabled={actionType === "edit"}
                          />
                        )}
                        {(actionType != "view" && actionType !== "edit") && (
                          <InputGroupAddon
                            addonType="append"
                            className="d-flex align-items-center"
                          >
                            <img src={IconCalendar} alt="icon" />
                          </InputGroupAddon>
                        )}
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>
                        <span>*</span> Người thu
                      </Label>
                      <Select
                        placeholder={
                          actionType === "view" && !data?.receipts_uid
                            ? "---"
                            : "Chọn người thu"
                        }
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView || isSource || isSupplier || actionType === "edit"}
                        onChange={(val: any) => {
                          setData({ ...data, receipts_uid: val?.value });
                        }}
                        value={users?.filter(
                          (option: any) => data?.receipts_uid == option.value
                        )}
                        options={users}
                        styles={customStyles}
                      ></Select>
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>
                        {(data?.receipts_group === "supplier" ||
                          data?.receipts_group === "customer" || data?.receipts_group === "user") && (
                            <span>*</span>
                          )}{" "}
                        Mã chứng từ gốc
                      </Label>
                      {actionType === "view" || isSource || (actionType === "edit" && dataCurrent?.source_code !== null && dataCurrent?.source_code !== undefined && dataCurrent?.source_code?.length !== 0) ? (
                        <>
                          {/* <Input type="text" value={data?.source_code?.join(',') || '---'} placeholder="Nhập mã chứng từ" /> */}
                          <div>
                            {source_code?.map((item: any, index: number) => {
                              return (
                                <>
                                  {index !== 0 ? ", " : ""}
                                  <Link
                                    key={`source_code-${index}`}
                                    to={getLinkBySourceCode(item?.name || "")}
                                  >
                                    {item?.name}
                                  </Link>
                                </>
                              );
                            })}
                          </div>
                        </>
                      ) : (
                        <AsyncSelect
                          className="react-select mb-2"
                          classNamePrefix="react-select"
                          onInputChange={handleInputChangeSearchCode}
                          loadOptions={loadSearchCode}
                          inputValue={queryDesignation}
                          placeholder={
                            loadingDesignation
                              ? "Đang tải dữ liệu..."
                              : "Nhập mã chứng từ"
                          }
                          noOptionsMessage={() =>
                            queryDesignation
                              ? "Không tìm thấy dữ liệu"
                              : "Nhập mã chứng từ"
                          }
                          loadingMessage={() => "searching..."}
                          styles={customStyles}
                          cacheOptions
                          isMulti
                          onChange={(val: any) => {
                            const source_code = val
                              ? val?.reduce((prev: any, item: any) => {
                                prev = [...prev, item?.code];
                                return prev;
                              }, [])
                              : [];
                            setData({ ...data, source_code: source_code });
                          }}
                          value={data?.source_code?.reduce(
                            (prev: any, item: any) => {
                              prev = [
                                ...prev,
                                {
                                  value: item,
                                  label: item,
                                  code: item,
                                },
                              ];
                              return prev;
                            },
                            []
                          )}
                          isDisabled={actionType === "view"}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>
                        <span>*</span> Số tiền
                      </Label>
                      <NumberFormat
                        onChange={(e: any) => {
                          let value = TextUtils.onlyNumber(e.target.value);
                          if (
                            data?.max_payment_total &&
                            Number(value) > Number(data?.max_payment_total)
                          ) {
                            value = data?.max_payment_total;
                            toast.warning("Vượt quá số tiền cần phải thanh toán");
                          }
                          setData({ ...data, payment_total: value });
                        }}
                        name={"payment_total"}
                        type={"text"}
                        className="form-control"
                        value={
                          actionType === "view" && !data?.payment_total
                            ? "---"
                            : data?.payment_total
                        }
                        placeholder={
                          actionType == "view" && !data?.payment_total
                            ? "---"
                            : "Nhập số tiền..."
                        }
                        thousandSeparator={true}
                        disabled={actionType === "edit"}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>
                        <span>*</span> Hình thức
                      </Label>
                      <Select
                        placeholder={
                          actionType === "view" && !data?.payment_method_id
                            ? "---"
                            : "Chọn hình thức"
                        }
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView || action?.type === "edit"}
                        onChange={(val: any) => {
                          setType_payment_method_id(val);
                          setData({ ...data, payment_method_id: val?.value, payment_method_name: val?.name, fundaccount_id: '' });
                        }}
                        value={paymentMethod?.filter(
                          (option: any) => data?.payment_method_id == option.value
                        )}
                        options={paymentMethod}
                        styles={customStyles}
                      ></Select>
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>
                        <span>*</span> Cơ sở nhận tiền
                      </Label>
                      <Select
                        placeholder={
                          actionType === "view" && !data?.branch_id
                            ? "---"
                            : "Chọn cơ sở"
                        }
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        // isDisabled={onlyView || isSource || actionType === "edit"}
                        isDisabled={onlyView}
                        onChange={(val: any) => {
                          setData({ ...data, branch_id: val?.value });
                        }}
                        value={branch?.filter(
                          (option: any) => data?.branch_id == option.value
                        )}
                        options={branch}
                        menuPlacement="top"
                        styles={customStyles}
                      ></Select>
                    </FormGroup>
                    {dataCustomer?.id && (
                      <FormGroup className="nutri-form">
                        <Label>Công nợ hiện tại</Label>
                        <ValueText>
                          <b>
                            {PriceUtils.format(dataCustomer?.total_debt || 0)}
                          </b>
                        </ValueText>
                      </FormGroup>
                    )}
                    {dataSupplier?.id && (
                      <FormGroup className="nutri-form">
                        <Label>Công nợ hiện tại</Label>
                        <ValueText>
                          <b>
                            {PriceUtils.format(dataSupplier?.total_debt || 0)}
                          </b>
                        </ValueText>
                      </FormGroup>
                    )}
                  </Col>
                  {[
                    payment_method.vnpay_qr_id,
                    payment_method.vnpay_spos_id,
                  ].includes(Number(data?.payment_method_id)) && (
                      <Col md={4} xs={12}>
                        <FormGroup className="nutri-form">
                          <Label>
                            <span>*</span> Chọn máy POS
                          </Label>
                          <Select
                            placeholder={
                              actionType === "view" && !data?.vnpay_terminal_id
                                ? "---"
                                : "Chọn máy POS"
                            }
                            className="react-select mb-2"
                            classNamePrefix="react-select"
                            isDisabled={onlyView}
                            onChange={(val: any) => {
                              setData({ ...data, vnpay_terminal_id: val?.value });
                            }}
                            value={vnpayTerminal?.filter(
                              (option: any) =>
                                data?.vnpay_terminal_id == option.value
                            )}
                            options={vnpayTerminal}
                            styles={customStyles}
                          ></Select>
                        </FormGroup>
                      </Col>
                    )}
                  <Col md={4} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>Ghi chú</Label>
                      <Input
                        type="text"
                        value={
                          actionType === "view" && !data?.note ? "---" : data?.note
                        }
                        onChange={(e: any) => handleChangeInput(e)}
                        name="note"
                        placeholder="Nhập ghi chú"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                      <Label><span>*</span> Tài khoản quỹ</Label>
                      <Select
                        placeholder={
                          actionType === "view" && !data?.fundaccount_id
                            ? "---"
                            : "Chọn tài khoản quỹ"
                        }
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={view || (actionType == 'edit' && dataCheck?.fundaccount_id)}
                        onChange={(val: any) => {
                          setData({ ...data, fundaccount_id: val?.value });
                        }}
                        value={fundaccount?.filter(
                          (option: any) =>
                            data?.fundaccount_id == option.value
                        )}
                        options={fundaccount}
                        maxMenuHeight={100}

                      // styles={customStyles}
                      ></Select>
                    </FormGroup>
                  </Col>
                  {actionType == "view" && (
                    <>
                      <Col md={4} xs={12}>
                        <FormGroup className="nutri-form">
                          <Label>Trạng thái</Label>
                          <ValueText
                            className={
                              data?.status == 1 ? "text-success" : "text-dark"
                            }
                          >
                            {data?.status == 1
                              ? "Đã thu"
                              : data?.status == -1
                                ? "Thất bại"
                                : "Mới"}
                          </ValueText>
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup className="nutri-form">
                          <Label>Người tạo</Label>
                          <ValueText>{data?.created_uid?.name}</ValueText>
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup className="nutri-form">
                          <Label>Thời gian tạo</Label>
                          <ValueText>
                            {moment(data?.created_time).format(
                              "HH:mm:ss DD/MM/YYYY"
                            )}
                          </ValueText>
                        </FormGroup>
                      </Col>
                    </>
                  )}
                </Row>
              </FormGroup>
            </Col>
          </PageContent>
        </div>
        {actionType !== "view" ? (
          <div className="modal-footer">
            {(data?.payment_total < data?.max_payment_total || btnPrint() !== true) ? null : (
              <Button
                className="ml-2"
                color="success"
                type="button"
                onClick={() => {
                  handleSubmit(true)
                  // receiptPrint()
                }}
              >
                Lưu và In
              </Button>
            )}



            <Button
              onClick={() => {
                actionType === "add" && handleSubmit();
                actionType === "addReceipts" && handleSubmit();
                actionType === "edit" && handleEdit();
              }}
              className="ml-2"
              color="success"
              type="button"
            >
              {actionType === "add" || actionType === "addReceipts" || actionType === "edit"
                ? "Lưu"
                : "Xác nhận"}
            </Button>
            {actionType === "edit" && (
              <Button
                onClick={() => {
                  closeModal()
                }}
                className="success-bland ml-2"
                color="success"
                type="button"
              >
                Huỷ
              </Button>
            )}
          </div>
        ) : (
          <>
            {data?.status === 0 && (
              <div className="modal-footer">
                <Button
                  onClick={() => {
                    handleActionModal({
                      type: "receiptsUpdateStatusConfirm",
                      data: {
                        statusText: "Hủy",
                      },
                      onSubmit: () => {
                        handleUpdateStatus(-1);
                      },
                      onClose: () => {
                        setIsOpen(false);
                      },
                    });
                  }}
                  className="ml-2 success-bland"
                  color="success"
                  type="button"
                >
                  Hủy
                </Button>
                <Button
                  onClick={() => {
                    handleActionModal({
                      type: "receiptsUpdateStatusConfirm",
                      data: {
                        statusText: "Đã thu",
                      },
                      onSubmit: () => {
                        handleUpdateStatus(1);
                      },
                      onClose: () => {
                        setIsOpen(false);
                      },
                    });
                  }}
                  className="ml-2"
                  color="success"
                  type="button"
                >
                  Đã thu
                </Button>
              </div>
            )}
            <div className="modal-footer">
              <Button
                onClick={() => {
                  setActionType("edit")
                  setView(undefined)
                }}
                className="ml-2"
                color="success"
                type="button"
              >
                Chỉnh sửa
              </Button>
            </div>
          </>

        )}
        {loading && <Loader />}
        <ModalPopup
          isOpen={modalIsOpen}
          onRequestClose={() => {
            if (actionInner?.onClose) {
              actionInner.onClose();
            }
            setIsOpen(false);
          }}
        >
          <RenderActionModal
            {...props}
            closeModal={() => setIsOpen(false)}
            action={actionInner}
            paymentSynce={paymentSynce}
          />
        </ModalPopup>
        <div
          style={{ overflow: "hidden", height: 0 }}
        >
          <ReceiptsPrint
            branch={branchPrint}
            data={dataPrint}
            componentRef={componentRef}
            doctorPrint={doctorPrint}
            source_code={data?.source_code}
            payment_method_name={data?.payment_method_name}
            customerPrint={customerPrint}
            service_package_print={service_package_print}
          />
        </div>
      </CardBody>


    </>


  );
};

const PageContent = styled.div`
  &.only-view {
    .nutri-form {
      input {
        border: none;
        pointer-events: none;
      }
      .react-select__indicators {
        display: none !important;
      }
      .react-select__control {
        border: none;
        background-color: transparent !important;
      }
    }
  }
`;

const ValueText = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
`;

const customStyles = {
  menuList: (base: any) => ({
    ...base,
    maxHeight: 200,
    overflowY: "auto",
  }),
};

const mapState = (state: any) => {
  return {
    user: state.Auth.user,
  };
};

export default connect(mapState)(Detail);
